import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
// ROuter
import { Link } from 'react-router-dom';
// MATERIAL-UI
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
// COMPONENTS
import ExportHistoryDlg from './ExportHistoryDlg';
// CONSTANTS
import { moduleConfig } from '../../../lib/config/appConstants';
// CONSTANTS
import {
  USER_TYPE_TEST,
  USER_TYPE_ENTERPRISE,
  USER_TYPE_ONLINE,
  USER_TYPE_ZYWAVE,
} from '../../../lib/config/appConstants';
// FETCH & CONFIG
import SiteFetch from '../../../fetch/SiteFetch';
// STYLE & ICONS
import Build from '@mui/icons-material/Build';
import MapsPlace from '@mui/icons-material/Place';
import DonutSmall from '@mui/icons-material/DonutSmall';
import { white } from '../../../styles/miEdgeColors';
import { zuiBlue } from '../../../styles/colors/zuiBlue';
// LIBS
import { ZuiIcon } from '../../Zui/ZuiIcon';

// Define a shared sx style for menu item Typography
const menuItemTypographySx = (theme) => ({
  flexGrow: 1,
  paddingLeft: theme.spacing(1),
  textTransform: 'none',
});

class ToolsMenu extends React.Component {
  getInitialState = () => {
    return {
      menuOpen: false,
      anchorEl: null,
    };
  };

  constructor(props) {
    super(props);

    const MFA_LOGIN = '1';
    const ACL_EXPORT_HISTORY = '1';

    let allowExportHistory = false;
    let allowEnableIndustries = true;
    let user_acl_export_history_enable = '0';
    let user_mfa = '';
    let user_type = '';

    const { userInfo, module } = this.props;

    // Extract user info from PROPS
    if (userInfo) {
      user_type = userInfo.account_type;
      user_mfa = userInfo.require_mfa_login;

      if (userInfo.miedge_acl && userInfo.miedge_acl.EXPORT_HISTORY_ENABLE) {
        user_acl_export_history_enable = userInfo.miedge_acl.EXPORT_HISTORY_ENABLE;
      }

      if (
        user_type === USER_TYPE_TEST ||
        user_type === USER_TYPE_ZYWAVE ||
        user_mfa === MFA_LOGIN ||
        user_acl_export_history_enable === ACL_EXPORT_HISTORY
      ) {
        //accounts with MFA enabled, or test users or, acl export history enable
        allowExportHistory = true;
      }

      // #916 & #915: Turn off Exports History and disable Industries for new online users
      if (
        userInfo.account_type == USER_TYPE_ENTERPRISE ||
        userInfo.account_type == USER_TYPE_ONLINE ||
        userInfo.account_type == USER_TYPE_ZYWAVE
      ) {
        if (module === moduleConfig.PC.shortName) {
          allowExportHistory = userInfo.enable_pc_export_csv === '1';
        } else if (module === moduleConfig.EB.shortName) {
          allowExportHistory = userInfo.enable_eb_export_csv === '1';
        }
        if (userInfo.account_type == USER_TYPE_ONLINE && userInfo.enable_adv_search === '0') {
          allowEnableIndustries = false;
        }
      }

      const enableShowToolsMenu =
        module === moduleConfig.PC.shortName || module === moduleConfig.EB.shortName;

      this.state = Object.assign({}, this.getInitialState(props), {
        allowExportHistory: allowExportHistory,
        allowEnableIndustries: allowEnableIndustries,
        enableShowToolsMenu: enableShowToolsMenu,
        exportHistoryDlgOpen: false,
        exportHistoryList: [],
        exportHistoryIntervalID: 0,
      });
    }
  }

  render() {
    const { module, allowStatistics } = this.props;
    const { anchorEl, allowExportHistory, allowEnableIndustries, enableShowToolsMenu, menuOpen } =
      this.state;

    if (!enableShowToolsMenu) {
      return <Fragment />;
    }

    return (
      <Fragment>
        <Button
          onClick={this.handleClickToolsMenu}
          sx={(theme) => ({
            color: white,
            textTransform: 'capitalize',
            minWidth: theme.spacing(14),
            padding: theme.spacing(1, 2),
          })}
        >
          <Build
            sx={{
              color: white,
              mr: 1,
            }}
          />
          <Typography
            variant="button"
            sx={{
              color: white,
              textTransform: 'capitalize',
            }}
          >
            Tools
          </Typography>
        </Button>
        <Menu
          id="headerUsername"
          anchorEl={anchorEl}
          open={menuOpen}
          onClose={this.handleCloseToolsMenu}
        >
          {module === moduleConfig.PC.shortName && (
            <MenuItem
              id="headerLocationLookup"
              component={React.forwardRef((props, ref) => (
                <Link to="/edge/location_lookup" {...props} ref={ref} />
              ))}
            >
              <MapsPlace sx={{ mr: 1 }} />
              <Typography variant="body1" sx={menuItemTypographySx}>
                Location Lookup
              </Typography>
            </MenuItem>
          )}
          {module === moduleConfig.PC.shortName && (
            <MenuItem
              id="headerIndustries"
              component={React.forwardRef((props, ref) => (
                <Link to="/edge/industries" {...props} ref={ref} />
              ))}
              disabled={!allowEnableIndustries}
            >
              <DonutSmall
                sx={(theme) => ({
                  color: zuiBlue[500],
                  mr: 1,
                })}
              />
              <Typography variant="body1" sx={menuItemTypographySx}>
                Industries
              </Typography>
            </MenuItem>
          )}
          {allowExportHistory && (
            <MenuItem id="headerExportHistory" onClick={() => this.onClickExportHistoryMenu()}>
              <ZuiIcon icon="zui-download" sx={{ mr: 1 }} />
              <Typography variant="body1" sx={menuItemTypographySx}>
                Export History
              </Typography>
            </MenuItem>
          )}
          <MenuItem
            id="headerTrackExports"
            component={React.forwardRef((props, ref) => (
              <Link to={`${moduleConfig[module].home}/track_exports`} {...props} ref={ref} />
            ))}
          >
            <ZuiIcon icon="zui-multiple-files" sx={{ mr: 1 }} />
            <Typography variant="body1" sx={menuItemTypographySx}>
              Track Exports
            </Typography>
          </MenuItem>
          {allowStatistics && (
            <MenuItem
              id="headerStatistics"
              component={React.forwardRef((props, ref) => (
                <Link to={`/edge/statistics/${module.toLowerCase()}`} {...props} ref={ref} />
              ))}
            >
              <ZuiIcon icon="zui-reporting" sx={{ mr: 1 }} />
              <Typography variant="body1" sx={menuItemTypographySx}>
                Statistics
              </Typography>
            </MenuItem>
          )}
        </Menu>

        <ExportHistoryDlg
          open={this.state.exportHistoryDlgOpen}
          exportHistoryList={this.state.exportHistoryList}
          onCloseRequested={this.onCloseExportHistoryDlgRequested}
        />
      </Fragment>
    );
  }

  onClickExportHistoryMenu = () => {
    SiteFetch.getExportHistoryInfo(this.props.module).then((json) => {
      this.setState({
        exportHistoryList: json.downloads,
        exportHistoryDlgOpen: true,
        exportHistoryIntervalID: setInterval(() => this.exportHistoryGetData(), 10000),
      });
    });

    this.handleCloseToolsMenu();
  };

  handleClickToolsMenu = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
      menuOpen: true,
    });
  };

  handleCloseToolsMenu = () => {
    this.setState({
      anchorEl: null,
      menuOpen: false,
    });
  };

  onCloseExportHistoryDlgRequested = () => {
    this.setState({
      exportHistoryDlgOpen: false,
    });
    this.state.exportHistoryIntervalID !== 0 && clearInterval(this.state.exportHistoryIntervalID);
  };

  exportHistoryGetData = () => {
    SiteFetch.getExportHistoryInfo(this.props.module).then((json) => {
      // Stop fetching if not any Processing task.
      const keepFetching =
        json.downloads.filter((item) => {
          return item.process_status.toUpperCase() === 'PROCESSING';
        }).length > 0;
      let updatedIntervalID = this.state.exportHistoryIntervalID;
      if (keepFetching === false) {
        this.state.exportHistoryIntervalID !== 0 &&
          clearInterval(this.state.exportHistoryIntervalID);
        updatedIntervalID = 0;
      }
      this.setState({
        exportHistoryList: json.downloads,
        exportHistoryIntervalID: updatedIntervalID,
      });
    });
  };
}

ToolsMenu.propTypes = {
  userInfo: PropTypes.object.isRequired,
  onAppError: PropTypes.func.isRequired,
  module: PropTypes.oneOf([moduleConfig.PC.shortName, moduleConfig.EB.shortName]),
  allowStatistics: PropTypes.bool,
};

export default ToolsMenu;
